import { EmailAddress } from '@dreryk/email-address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { EmailAddressInput } from '@dreryk/react-components';

export const EMAIL_FIELD_NAME = 'email';
export const EMAIL_AUTOCOMPLETE_TOKEN = 'email';

export type EmailFormBeanPart = {
   [EMAIL_FIELD_NAME]: EmailAddress;
};

type EmailFieldProps = {
   readonly register: BindingCreator<EmailFormBeanPart, typeof EMAIL_FIELD_NAME>;
};

export const EmailField = (props: EmailFieldProps): JSX.Element => {
   return (
      <EmailAddressInput
         controller={props.register(EMAIL_FIELD_NAME, {
            required: true,
         })}
         testId={EMAIL_FIELD_NAME}
         autoComplete={EMAIL_AUTOCOMPLETE_TOKEN}
      />
   );
};
